import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, isDevMode, provideAppInitializer } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Router } from '@angular/router';
import { provideServiceWorker, SwPush } from '@angular/service-worker';
import { AppConfig } from './app-services/config/config.app';
import { FactoryAppConfig } from './app-services/config/config.app.factory';
import { AppMonitoring } from './app-services/monitoring/monitor.app';
import { AppSnackBar } from './app-services/snackbar/snackbar.app';
import { InterceptorError } from './interceptors/error.interceptor';
import { MicrosoftAuthenticationLibraryModule } from './modules/microsoft-authentication-library/microsoft-authentication-library.module';
import { routes } from './routes/app.routes';
import { AbstractServiceAdvertisement } from './services/advertisement.service/advertisement.service.abstract';
import { FactoryServiceAdvertisement } from './services/advertisement.service/advertisement.service.factory';
import { AbstractServiceAzureStorage } from './services/azure-storage.service.ts/azure-storage.service.abstract';
import { FactoryServiceAzureStorage } from './services/azure-storage.service.ts/azure-storage.service.factory';
import { AbstractServiceCampaignInsights } from './services/campaign-insights/campaign-insights.abstract';
import { FactoryServiceCampaignInsights } from './services/campaign-insights/campaign-insights.factory';
import { AbstractEndpoints } from './services/endpoints/endpoints.service.abstract';
import { FactoryEndpoints } from './services/endpoints/endpoints.service.factory';
import { AbstractServiceNotification } from './services/notifications/notification.service.abstract';
import { FactoryServiceNotification } from './services/notifications/notification.service.factory';
import { AbstractServiceOrganization } from './services/organization.service/organization.service.abstract';
import { FactoryServiceOrganization } from './services/organization.service/organization.service.factory';

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    importProvidersFrom(MicrosoftAuthenticationLibraryModule.forRoot()),
    { provide: MAT_DATE_LOCALE, useValue: 'en-ZA' },
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideRouter(routes),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode() || window.location.protocol === 'https:',
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideAppInitializer(() => {
        const initializerFn = (FactoryAppConfig)(inject(AppConfig), inject(Router));
        return initializerFn();
      }),
    { provide: AbstractEndpoints, useFactory: FactoryEndpoints, deps: [AppConfig, AppMonitoring] },
    { provide: AbstractServiceAdvertisement, useFactory: FactoryServiceAdvertisement, deps: [HttpClient, AbstractEndpoints, AppMonitoring, AppConfig] },
    { provide: AbstractServiceAzureStorage, useFactory: FactoryServiceAzureStorage, deps: [HttpClient, AbstractEndpoints, AppMonitoring, AppConfig] },
    { provide: AbstractServiceCampaignInsights, useFactory: FactoryServiceCampaignInsights, deps: [HttpClient, AbstractEndpoints, AppMonitoring, AppConfig] },
    { provide: AbstractServiceNotification, useFactory: FactoryServiceNotification, deps: [HttpClient, AbstractEndpoints, AppConfig, AppMonitoring, SwPush, AppSnackBar, AbstractServiceAzureStorage] },
    { provide: AbstractServiceOrganization, useFactory: FactoryServiceOrganization, deps: [HttpClient, AbstractEndpoints, AppMonitoring, AppConfig] },
    // { provide: HTTP_INTERCEPTORS, useClass: InterceptorLoadingScreen, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorError, multi: true }
  ]
};
